// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"64b0a6eb","348":"d8a334f1","571":"d4339fad","924":"f7e45845"}[chunkId] + ".chunk.js";
};